import {FETCH_ADMIN_TEAMS_BEGIN, FETCH_ADMIN_TEAMS_SUCCESS, FETCH_ADMIN_TEAMS_FAILURE} from '../constants/action-types';

const initialState = {
  teamsData: {},
  loading: false,
  error: null
};

export default function teamsManagementReducer(state = initialState, action) {
  switch(action.type) {
    case FETCH_ADMIN_TEAMS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_ADMIN_TEAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        teamsData: action.payload.teamsData
      };

    case FETCH_ADMIN_TEAMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        teamsData: {}
      };

    default:
      return state;
  }
}
